var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.182 0.734493C14.9115 0.910112 14.716 0.970901 14.1296 1.4167C12.7914 2.42988 10.085 5.82065 8.22805 8.80615C7.69428 9.67073 6.10048 12.5009 5.74714 13.2169L5.53664 13.6491L5.13819 13.102C4.28115 11.9267 3.61205 11.3256 2.77004 10.9744C2.00322 10.6501 1.27398 10.792 0.492114 11.4066C-0.184498 11.947 -0.169462 12.2982 0.574811 13.0615C1.55966 14.0747 2.334 14.9663 2.99558 15.8309C3.98043 17.1277 3.83759 17.0467 5.19833 17.0467C6.74702 17.0467 6.79213 17.0264 7.27328 16.1078C7.46874 15.7295 7.84464 14.9528 8.11528 14.3786C9.20538 12.0078 10.9721 9.06282 12.6787 6.76628C14.2424 4.66563 15.4528 3.30121 17.024 1.86925C17.8284 1.13977 18.0389 0.916866 18.0164 0.78853C17.9938 0.646685 17.9562 0.633177 17.5428 0.619667C17.2947 0.612913 16.6782 0.666948 16.182 0.734493Z",
    fill: "#71C55D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.c1a0f6007b1d4ae881b19a1c21ceaa3b.svg";
export { ForwardRef as ReactComponent };